import {
  Item2,
  Root2
} from "../../../chunk-2AGHUWXU.mjs";
import "../../../chunk-NGPEH7IU.mjs";
import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-XYZUYCEL.mjs";
import "../../../chunk-MTQX4T3Q.mjs";
import "../../../chunk-SDALGTJ4.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-HFXIPTW6.mjs";
import "../../../chunk-GYRZVAMU.mjs";
import "../../../chunk-QOCR4XUU.mjs";
import "../../../chunk-D6QHF2UO.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/SegmentedControl/SegmentedControl.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var IS_DEV = process.env.NODE_ENV !== "production";
var MAX_ITEMS = 8;
var segmentedControlVariants = cva("buyscout-segmented-control", {
  variants: {
    variant: {
      default: "",
      tinted: "buyscout-segmented-control--variant-tinted",
      glass: "buyscout-segmented-control--variant-glass",
      quiet: "buyscout-segmented-control--variant-quiet"
    },
    size: {
      sm: "buyscout-segmented-control--size-sm",
      md: "buyscout-segmented-control--size-md",
      lg: "buyscout-segmented-control--size-lg"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
});
var segmentedControlItemVariants = cva("buyscout-segmented-control__item");
function SegmentedControl({
  ref,
  variant,
  size,
  className,
  children,
  ...rest
}) {
  const rootRef = React.useRef(null);
  const warnedRef = React.useRef(false);
  const setRoot = React.useCallback((node) => {
    rootRef.current = node;
    if (typeof ref === "function") ref(node);
    else if (ref) ref.current = node;
  }, [ref]);
  React.useEffect(() => {
    if (!IS_DEV || warnedRef.current) return;
    if ((rootRef.current?.querySelectorAll('[role="radio"]').length ?? 0) <= MAX_ITEMS) return;
    warnedRef.current = true;
    console.warn(`SegmentedControl places its selection for at most ${MAX_ITEMS} items; offer more choices in a Select.`);
  });
  return /* @__PURE__ */ jsx(
    Root2,
    {
      ref: setRoot,
      orientation: "horizontal",
      className: segmentedControlVariants({ variant, size, className }),
      ...rest,
      children
    }
  );
}
SegmentedControl.displayName = "SegmentedControl";
function SegmentedControlItem({
  ref,
  className,
  children,
  ...rest
}) {
  return /* @__PURE__ */ jsx(Item2, { ref, className: segmentedControlItemVariants({ className }), ...rest, children: /* @__PURE__ */ jsx("span", { className: "buyscout-segmented-control__label", children }) });
}
SegmentedControlItem.displayName = "SegmentedControlItem";
export {
  SegmentedControl,
  SegmentedControlItem
};
//# sourceMappingURL=SegmentedControl.mjs.map